import type { ExcursionPage } from "../slug-excursions";
import verdon from "@/assets/images/excursions/destinations/verdon.webp";

const page: ExcursionPage = {
  slug: "verdon",
  hero: {
    title: "Excursion Verdon",
    subtitle:
      "Gorges du Verdon et lacs azur : nature grandiose au départ de Cannes.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: verdon,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Gorges du Verdon et falaises vertigineuses" },
      { text: "Lacs turquoise et belvédères" },
      { text: "Villages provençaux en option" },
      { text: "Routes panoramiques et ponts emblématiques" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      { title: "Route vers le Verdon", description: "Arrêts panoramiques." },
      { title: "Belvédères", description: "Photos, temps libre selon météo." },
      {
        title: "Lac (option)",
        description: "Sainte‑Croix / St‑Cassien selon parcours.",
      },
      { title: "Retour", description: "Confort et sécurité." },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "8 à 10 heures" },
      { label: "Conseil", value: "Emporter eau et protection solaire" },
      { label: "Départ", value: "Cannes" },
      { label: "Chaussures", value: "Prévoir chaussures adaptées" },
    ],
  },
};

export default page;
